var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card shadow"},[(!_vm.loading)?[_c('div',{staticStyle:{"height":"80vh"}},[_c('iframe',{staticStyle:{"border":"0"},attrs:{"width":"100%","height":"100%","src":_vm.src}})])]:_vm._e(),(_vm.loading)?[_c('quest-preloader')]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }